export const clearFlash = () => ({
  type: 'CLEAR_FLASH',
})

export const setFlash = (message, type = 'notice') => ({
  flash: { message, type },
  type: 'SET_FLASH',
})
